// extracted by mini-css-extract-plugin
export default {"marginLeft_8":"marginLeft_8___JGPuz","marginLeft_4":"marginLeft_4___YD0uF"};